import type { MindstringPrototype, Situation } from "@/generated/fastapi";

export const EMPTY_PROTOTYPE_COUNTS: Record<MindstringPrototype, number> = {
  job_activity: 0,
  learning_outcome: 0,
  workplace_characteristic: 0,
  individual_description: 0,
};

/**
 * Sort situations using the backend's ordering rules:
 * futures first, then newest first.
 */
export function sortSituations(situations: Situation[]): Situation[] {
  return [...situations].sort((a, b) => {
    if (a.has_started !== b.has_started) {
      return a.has_started ? 1 : -1;
    }

    const getTimestamp = (situation: Situation): number => {
      if (situation.date_to) return new Date(situation.date_to).getTime();
      if (situation.date_at) return new Date(situation.date_at).getTime();
      if (situation.date_from) return new Date(situation.date_from).getTime();
      return Number.MAX_SAFE_INTEGER;
    };

    return getTimestamp(b) - getTimestamp(a);
  });
}

export function filterSituationsByPrototypes(
  situations: Situation[],
  prototypes: MindstringPrototype[],
): Situation[] {
  if (prototypes.length === 0) {
    return situations;
  }

  return situations.filter((situation) =>
    prototypes.every((prototype) => situation.prototypes.includes(prototype)),
  );
}

export function countSituationsByPrototype(
  situations: Situation[] | null | undefined,
): Record<MindstringPrototype, number> {
  const counts = { ...EMPTY_PROTOTYPE_COUNTS };

  for (const situation of situations ?? []) {
    for (const prototype of situation.prototypes) {
      counts[prototype] += 1;
    }
  }

  return counts;
}
